import script from "./digitalManDetail.vue?vue&type=script&lang=ts&setup=true"
export * from "./digitalManDetail.vue?vue&type=script&lang=ts&setup=true"

import "./digitalManDetail.vue?vue&type=style&index=0&id=34d34b7c&lang=scss&scoped=true"
import "./digitalManDetail.vue?vue&type=style&index=1&id=34d34b7c&lang=scss"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-34d34b7c"]])

export default __exports__